import React, {useContext} from 'react'
import MenuContent from '../components/MenuContent'
import {MyAccountContext} from '../containers/Layout'
import Program from './Program/Program'
import {Grid} from '@material-ui/core'
import Enrolled from './Enrolled'
import Qualified from './Qualified'
import AddEditUser from './AddEditUser'

const Home = () => {
    const {routeObject, setrouteObject} = useContext(MyAccountContext)
    const setRouter = routeinfo => {
        if (routeinfo === 'dashboard') {
            //  history.push('/myaccount')
        }
        setrouteObject({...routeObject, key: routeinfo})
    }

    const getBlockContainer = block => {
        // console.log('getBlockContainer object', block)
        switch (block.key) {
            case 'demographic':
            case 'location':
            case 'ed':
            case 'provider':
            case 'technical':
            case 'user':
                return <MenuContent componentName={block.key} setRouter={setRouter} />

            case 'addedituser':
                return (
                    <AddEditUser
                        componentName={block.key}
                        setRouter={setRouter}
                        object={block}
                    />
                )

            case 'subscribed':
            case 'available':
                delete block.clientprogramid
                delete block.clientprogramname
                return (
                    <Program
                        data={block}
                        setRouter={setRouter}
                        backRouter={block.backrouter}
                    />
                )

            case 'enrolled':
                return <Enrolled componentName={block.key} setRouter={setRouter} />
            case 'qualified':
                return <Qualified componentName={block.key} setRouter={setRouter} />

            default:
                return null
        }
    }

    return (
        <Grid item xs className="home-content_wrapper">
            {getBlockContainer(routeObject)}
        </Grid>
    )
}

export default Home
